import { createRouter, createWebHistory } from "vue-router";
import { getUserId } from "@/util/api";

const checkGuest = async (to: any, from: any, next: any) => {
    if (!(await getUserId())) {
        next();
        return;
    }
    next("/");
};
const checkAuthenticated = async (to: any, from: any, next: any) => {
    if (await getUserId()) {
        next();
        return;
    }
    next("/login");
};

const routes = [
    {
        path: "/",
        component: () => import("../Pages/Home.vue"),
        beforeEnter: checkAuthenticated,
    },
    {
        path: "/notifications",
        component: () => import("../Pages/Notifications.vue"),
        beforeEnter: checkAuthenticated,
    },
    {
        path: "/login",
        component: () => import("../Pages/Login.vue"),
        beforeEnter: checkGuest,
    },
    {
        path: "/forgotPassword",
        component: () => import("../Pages/ForgotPassword.vue"),
    },
    {
        path: "/resetPassword/:token",
        component: () => import("../Pages/ResetPassword.vue"),
    },
    {
        path: "/userInvitation/:token",
        component: () => import("../Pages/UserInvitation.vue"),
    },
    {
        path: "/forms/:id?",
        component: () => import("../Pages/Forms.vue"),
        beforeEnter: checkAuthenticated,
    },
    {
        path: "/vehicles",
        component: () => import("../Pages/Vehicles.vue"),
        beforeEnter: checkAuthenticated,
        meta: {
            permissionBaseName: "vehicle",
        },
    },
    {
        path: "/projects",
        beforeEnter: checkAuthenticated,
        children: [
            {
                path: "",
                component: () => import("@/Pages/Projects/List.vue"),
            },
            {
                path: "edit/:id",
                component: () => import("@/Pages/Projects/Edit.vue"),
            },
        ],
        meta: {
            permissionBaseName: "project",
        },
    },
    {
        path: "/jobs",
        beforeEnter: checkAuthenticated,
        children: [
            {
                path: "edit/:id",
                component: () => import("@/Pages/Projects/Jobs/Edit.vue"),
                name: "jobs.edit",
            },
        ],
        meta: {
            permissionBaseName: "project",
        },
    },
    {
        path: "/workstreams",
        beforeEnter: checkAuthenticated,
        children: [
            {
                path: "edit/:id",
                component: () =>
                    import("@/Pages/Projects/Workstreams/Edit.vue"),
                name: "workstreams.edit",
            },
            {
                path: "types",
                children: [
                    {
                        path: "",
                        component: () =>
                            import("@/Pages/Projects/WorkTypes/List.vue"),
                    },
                    {
                        path: "edit/:id",
                        component: () =>
                            import("@/Pages/Projects/WorkTypes/Edit.vue"),
                    },
                ],
            },
        ],
        meta: {
            permissionBaseName: "project",
        },
    },

    {
        path: "/calendar",
        beforeEnter: checkAuthenticated,
        component: () => import("../Pages/Calendar.vue"),
        name: "calendar",
    },

    {
        path: "/job-dashboard",
        beforeEnter: checkAuthenticated,
        component: () => import("../Pages/JobDashboard.vue"),
        name: "job-dashboard",
    },

    // Admin Navigation Tree
    // todo: move into its own file
    {
        path: "/admin",
        beforeEnter: checkAuthenticated,
        //todo: add admin check
        children: [
            {
                path: "users",
                component: () => import("@/Pages/Layout/UserManagement.vue"),
                meta: {
                    permissionBaseName: "user",
                    breadcrumb: {
                        name: "Team",
                    },
                },
                children: [
                    {
                        path: "teams",
                        name: "admin.teams",
                        children: [
                            {
                                path: "",
                                component: () =>
                                    import("../Pages/Team/Team.vue"),
                            },
                            {
                                path: "create",
                                component: () =>
                                    import("../Pages/Team/Create.vue"),
                                meta: {
                                    breadcrumb: {
                                        name: "Create",
                                    },
                                },
                            },
                            {
                                path: ":id",
                                component: () =>
                                    import("../Pages/Team/Show.vue"),
                                meta: {
                                    breadcrumb: {
                                        name: "Edit/:id",
                                    },
                                },
                            },
                        ],
                        meta: {
                            permissionBaseName: "teams",
                        },
                    },
                    {
                        path: "permissions",
                        name: "admin.permissions",
                        component: () =>
                            import("../Pages/Permissions/Permissions.vue"),
                    },
                    {
                        path: "",
                        name: "admin.users",
                        component: () => import("@/Pages/Users.vue"),
                    },
                    {
                        path: "tasklog/:id",
                        component: () =>
                            import("@/Pages/UserGeolocation/Geolocation.vue"),
                    },
                    {
                        path: "edit/:id",
                        component: () => import("@/Pages/User/Edit.vue"),
                    },
                ],
            },
            {
                path: "vehicles",
                component: () => import("@/Pages/Layout/VehicleManagement.vue"),
                name: "admin.vehicles",
                meta: {
                    permissionBaseName: "vehicle_admin",
                },
                children: [
                    {
                        path: "types",
                        name: "admin.vehicles.types",
                        children: [
                            {
                                path: "",
                                component: () =>
                                    import("@/Pages/Vehicles/VehicleTypes/VehicleTypesAdmin.vue"),
                            },
                            {
                                path: "edit/:id",
                                component: () =>
                                    import("@/Pages/Vehicles/VehicleTypes/VehicleTypeEdit.vue"),
                            },
                            {
                                path: "create",
                                component: () =>
                                    import("@/Pages/Vehicles/VehicleTypes/VehicleTypeCreation.vue"),
                            },
                        ],
                    },
                    {
                        path: "",
                        component: () =>
                            import("@/Pages/Vehicles/VehiclesAdmin.vue"),
                    },
                    {
                        path: "edit/:id",
                        component: () =>
                            import("@/Pages/Vehicles/VehicleEdit.vue"),
                    },
                    {
                        path: "create",
                        component: () =>
                            import("@/Pages/Vehicles/VehicleCreation.vue"),
                    },
                ],
            },
            {
                path: "people",
                children: [
                    {
                        path: "",
                        component: () =>
                            import("@/Pages/AdminPersonsClients/Individuals.vue"),
                    },
                    {
                        path: "create",
                        component: () =>
                            import("../Pages/AdminPersonsClients/CreateIndividual.vue"),
                    },
                    {
                        path: "edit/:id",
                        component: () =>
                            import("../Pages/AdminPersonsClients/EditIndividual.vue"),
                    },
                ],
                meta: {
                    permissionBaseName: "people",
                },
            },
            {
                path: "clients",
                meta: {
                    permissionBaseName: "clients",
                },
                children: [
                    {
                        path: "",
                        component: () =>
                            import("../Pages/AdminPersonsClients/Companies.vue"),
                    },
                    {
                        path: "edit/:id",
                        component: () =>
                            import("../Pages/AdminPersonsClients/ClientsPeople.vue"),
                    },
                    {
                        path: ":client_id/person/create/:id",
                        component: () =>
                            import("../Pages/AdminPersonsClients/ClientsPeopleCreate.vue"),
                    },
                    {
                        path: ":client_id/person/edit/:id",
                        component: () =>
                            import("../Pages/AdminPersonsClients/ClientsPeopleEdit.vue"),
                        props: true,
                    },
                ],
            },
            {
                path: "schedules",
                meta: {
                    permissionBaseName: "tasks",
                },
                children: [
                    {
                        path: "",
                        component: () => import("../Pages/Tasks/Tasks.vue"),
                    },
                    {
                        path: "create",
                        component: () =>
                            import("../Pages/Tasks/TaskCreate.vue"),
                    },
                    {
                        path: "edit/:id",
                        component: () => import("../Pages/Tasks/TaskEdit.vue"),
                    },
                ],
            },
            {
                path: "taxonomies",
                component: () => import("@/Pages/Taxonomies/List.vue"),
                meta: {
                    permissionBaseName: "taxonomies",
                },
            },
            {
                path: "forms",
                name: "admin.forms",
                meta: {
                    permissionBaseName: "form",
                },
                component: () => import("@/Pages/Layout/FormManagement.vue"),
                children: [
                    {
                        path: "submissions",
                        name: "admin.forms.submissions",
                        children: [
                            {
                                path: "",
                                component: () =>
                                    import("../Pages/Form/FormSubmissionAdmin.vue"),
                                name: "form-submissions.index",
                            },
                            {
                                path: ":id",
                                component: () =>
                                    import("../Pages/FormSubmission/Show.vue"),
                                name: "form-submissions.show",
                            },
                            {
                                path: "create",
                                component: () =>
                                    import("../Pages/FormSubmission/Create.vue"),
                                name: "form-submissions.create",
                            },
                        ],
                    },
                    {
                        path: "",
                        component: () => import("../Pages/Form/FormAdmin.vue"),
                    },
                    {
                        path: "create",
                        component: () => import("../Pages/FormCreation.vue"),
                    },
                    {
                        path: "edit/:id",
                        component: () =>
                            import("../Pages/Form/FormAdminEdit.vue"),
                    },
                ],
            },
        ],
    },
    {
        path: "/users/management",
        component: () => import("../Pages/UserManagement/UserManagement.vue"),
    },
];

export default createRouter({
    history: createWebHistory(),
    routes,
});
